const INITIAL_STATE = {
  rankingSettings: {
    headerPrimary: '',
    headerSecondary: '',
    headerAfterEnd: '',
    headerPreStart: '',
    headerContent: '',
    prizesContent: '',
    bottomContent: '',
    tableHeader: '',
    endTime: null,
    startTime: null,
    prizes: [],
    visible: false,
  },
  didInvalidate: true,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
};

module.exports = function StatisticsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'FETCH_RANKING_SETTINGS_IN_PROGRESS':
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    case 'FETCH_RANKING_SETTINGS_SUCCESSFUL':
      return {
        ...state,
        didInvalidate: false,
        rankingSettings: Object.assign(
          state.rankingSettings,
          action.rankingSettings,
        ),
        lastSuccessfulFetch: action.timestamp,
        fetchingInProgressSince: null,
      };
    case 'FETCH_RANKING_STATISTICS_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    default:
      return state;
  }
};
